import type { BaseProps } from '$lib/server/base-view-model/types';

type HomepageClippingHeroProps = BaseProps & {
  video: ComponentContent[];
  text: ComponentContent[];
  buttonLinks: ComponentContent[];
  videoLink: ComponentContent[];
  options: {
    shortVariant?: boolean;
    marginBottom?: string;
    overlayBackground?: string;
  };
};

export type { HomepageClippingHeroProps };

export enum OverlayType {
  Reveal = 'reveal',
  Before = 'before',
}
